import { HttpService } from "@/core";
import { ExportBtnReq, ExportBtnResp } from "./export-btn.interface";

export class ExportBtnService {
  static useExportApi() {
    const api = (url, data: any,method='POST') =>
      HttpService.axios({
        method: method,
        url,
        data,
      });
    return HttpService.useRequest<ExportBtnResp>(api, { isOutError: true });
  }
}
